/**
 * constants/routes.js — Single source of truth for all tab/route IDs.
 *
 * Usage:
 *   import { ROUTES, DEFAULT_ROUTE, ROUTE_LABELS } from '../constants/routes';
 *   setActiveTab(ROUTES.BUILD);
 */

export const ROUTES = {
  TODAY:   'today',
  BUILD:   'build',
  AI:      'ai-cofounder',
  COMPANY: 'company',
  // The Company tab is labelled "Money" everywhere the founder can see it.
  // Alias so code that navigates there reads like the app looks.
  MONEY:   'company',
  TEAM:    'team',
  ADMIN:   'admin',
};

/** The tab shown on first load */
export const DEFAULT_ROUTE = ROUTES.TODAY;

/** Human-readable labels used for page tracking and nav display */
export const ROUTE_LABELS = {
  [ROUTES.TODAY]:   'Today',
  [ROUTES.BUILD]:   'Build',
  [ROUTES.AI]:      'AI',
  [ROUTES.COMPANY]: 'Company',
  [ROUTES.TEAM]:    'Team',
  [ROUTES.ADMIN]:   'Admin',
};
